// @flow

import * as React from 'react';
import { View, Text, Pressable } from 'react-native';
import { ThemeContext, Icon } from 'react-native-elements';
import memoizeOne from 'memoize-one';
import { BLUE_COLOR } from 'src/styles/common';

const styles = memoizeOne(() => ({
    note: {
        overflow: 'hidden',
        borderRadius: 10,
        height: 'auto',
        paddingVertical: 20,
        paddingHorizontal: 50,
        maxWidth: '60%',
        alignItems: 'center',
        margin: '0 auto',
        borderWidth: 1,
        borderColor: BLUE_COLOR,
        alignSelf: 'center',
    },
    note_title: {
        color: '#757783',
    },
    close_button: {
        position: 'absolute',
        top: 5,
        right: 5,
    },
}));

type Props = {
    text: string,
    onClose?: Function,
};

const Note = (props: Props) => {
    const { theme } = React.useContext(ThemeContext);
    const { text, onClose } = props;

    const [show, setShow] = React.useState(true);

    const hide = () => {
        setShow(false);
    };

    return (
        show && (
            <View style={styles(theme).note}>
                <Pressable
                    style={styles(theme).close_button}
                    onPress={() => {
                        hide();
                        if (onClose) {
                            onClose();
                        }
                    }}
                >
                    <Icon
                        type="material"
                        name="close"
                        size={16}
                        color={BLUE_COLOR}
                    />
                </Pressable>
                <Text style={styles(theme).note_title}>{text}</Text>
            </View>
        )
    );
};

Note.defaultProps = {
    onClose: undefined,
};

export default Note;
